define [], ->
  resizeDashHeadWidth = ->
    table_width = $('.dash').innerWidth()
    lesson_width = $('.dashboard_lesson_title').css('width')
    $('#final_spacer').css('width', 857 - table_width)

  init: ->
    resizeDashHeadWidth()